import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioPersonalDiscountEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioPersonalDiscountEntity
